const fullImages = {
  phone: new URL('../images/hero-phone.jpg', import.meta.url),
  mac: new URL('../images/hero-mac.jpg', import.meta.url),
};

for (const [name, url] of Object.entries(fullImages)) {
  const image = document.querySelector(`.hero-image-${name}`);
  // Wait for the small placeholder so the full image doesn't compete for bandwidth.
  const upgrade = () => {
    const full = new Image();
    full.src = url;
    full.decode().then(() => { image.src = full.src; }, () => {});
  };
  if (image.complete) upgrade();
  else image.addEventListener('load', upgrade, { once: true });
}
